import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckboxSelect from "./CheckBox-Select";
import SingleSelect from "./SingleSelect";
import RadioGroup from "./RadioGroup";
import RangeSlider from "./RangeSlider";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { IoRefresh } from "react-icons/io5";
import {
  fetchFilters,
  selectFilters,
  resetFilters,
} from "../../../redux/filtersSlice";
import { toggleDrawer, toggleDrawerMobile } from "../../../redux/shopSlice";
import FiltersSkeleton from "../../designLayouts/skeletons/filtersSkeleton";
const ShopSideNav = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters);
  const { filters: filterData, status } = filters;
  const drawerOpen = useSelector((state) => state.view.drawer);
  const drawerOpenMobile = useSelector((state) => state.view.drawerMobile);
  const emptyFilters = useSelector((state) => state.filters.isFiltersEmpty);
  const min_price = useSelector((state) => state.filters.min_price);
  const max_price = useSelector((state) => state.filters.max_price);

  const filtersArray = Object.values(filterData);
  // Toggle drawer visibility
  const toggleDrawerOpen = () => {
    dispatch(toggleDrawerMobile());
  };

  useEffect(() => {
    // Dispatch fetchFilters action if filters are not already in the store
    if (status === "idle") {
      dispatch(fetchFilters());
    }
  }, [dispatch, status]);

  if (status === "loading") return <FiltersSkeleton />;
  if (status === "failed") throw new Error("failed to fetch filters");

  // Function to render filters based on type
  const renderFilter = (filter) => {
    const { name, value, type, multiple, detail = [] } = filter;
    const options = detail.map((option) => ({
      value: option.id,
      label: option?.name?.toUpperCase(),
    }));

    switch (type) {
      case "select":
        if (multiple) {
          return (
            <CheckboxSelect
              key={value}
              label={name}
              options={options}
              filterId={value}
            />
          );
        } else {
          return (
            <SingleSelect
              key={value}
              label={name}
              options={options}
              filterId={value}
              selected={filter?.selected}
            />
          );
        }
      case "radio":
        return (
          <RadioGroup
            key={value}
            label={name}
            options={options}
            filterId={value}
            selected={filter?.selected}
          />
        );
      case "range":
        return (
          <RangeSlider
            key={value}
            label={name}
            min={Number(filter.min_price) || 0}
            max={Number(filter.max_price) || 1000}
            step={10}
            initialRange={[100, 500]} // Adjust based on data
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="relative top-20 md:top-0 print:hidden">
      {/* Drawer toggle button (Hamburger menu for mobile) */}
      {/* <button
        onClick={toggleDrawerOpen}
        className="md:hidden text-base h-6 flex items-center gap-2 p-2 bg-primeColor text-white rounded absolute -top-[5.75rem]  z-10"
      >
        <FaFilter /> Filters
      </button> */}

      {/* Drawer (visible on mobile only) */}
      <div
        className={`${
          drawerOpenMobile ? "translate-x-0" : "-translate-x-full"
        } fixed inset-0 bg-gray-800 bg-opacity-50 z-30 md:hidden transition-transform ease-in-out duration-300`}
        onClick={toggleDrawerOpen}
      >
        <div
          className="absolute left-0 top-0  bg-white h-full p-2 md:p-6  overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={toggleDrawerOpen}
            className="absolute top-[4.25rem] right-4 text-2xl text-primeColor z-10"
          >
            <FaAngleLeft />
          </button>

          <div className="w-full flex flex-col gap-2 relative top-16 pb-10">
            {filtersArray.map((filter) => renderFilter(filter))}
            {max_price !== null && min_price != null && (
              <RangeSlider
                min={Number(min_price)}
                max={Number(max_price)}
                initialRange={[Number(min_price), Number(max_price)]}
                filterId={"range"}
              />
            )}
          </div>
        </div>
      </div>

      {/* Side nav for larger screens */}
      <div
        className={`hidden md:flex  ${
          drawerOpen ? "min-w-[130px]" : "w-0"
        } flex-col gap-2 relative`}
      >
        <div className={`${drawerOpen ? "flex" : "hidden"} justify-between`}>
          <p className="text-lg text-primeColor font-semibold">Filters</p>
          <span className="flex gap-2">
            {!emptyFilters && (
              <button
                className="flex text-white items-center rounded bg-red-500 p-2 h-6 gap-1 text-base"
                onClick={() => dispatch(resetFilters())}
              >
                <IoRefresh /> Reset
              </button>
            )}
            <button
              className={` text-primeColor  ${
                drawerOpen ? "block right-0 " : ""
              }`}
              onClick={() => dispatch(toggleDrawer())}
            >
              {drawerOpen ? (
                <FaAngleLeft size={18} />
              ) : (
                <FaAngleRight size={18} />
              )}
            </button>
          </span>
        </div>
        <button
          className={`absolute top-1 text-primeColor  ${
            drawerOpen ? "block right-0 " : ""
          }`}
          onClick={() => dispatch(toggleDrawer())}
        >
          {!drawerOpen && <FaAngleRight size={18} />}
        </button>
        {filtersArray.map((filter) => renderFilter(filter))}
        {max_price !== null && min_price != null && (
          <RangeSlider
            min={Number(min_price)}
            max={Number(max_price)}
            initialRange={[Number(min_price), Number(max_price)]}
            filterId={"range"}
          />
        )}
      </div>
    </div>
  );
};

export default ShopSideNav;
